import { gql, useMutation } from '@apollo/client'
import { UpdateCartCustomerMutation, UpdateCartCustomerMutationVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

const updateCartCustomerMutation = gql`
  ${cartFieldsFragment}

  mutation UpdateCartCustomer($id: ID!, $input: CartCustomerInput!) {
    updateCartCustomer(id: $id, input: $input) {
      ...CartFields
    }
  }
`

export const useUpdateCartCustomer = () => {
  return useMutation<UpdateCartCustomerMutation, UpdateCartCustomerMutationVariables>(updateCartCustomerMutation, { fetchPolicy: 'no-cache' })
}
